import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InfoCard } from "../../components/cards/infoCard";
import { EmptyEventState } from "../../components/empty/emptyEventState";
import { FullEventCard } from "../../components/event/fullEventCard";
import { Icon } from "../../components/icon/icon";
import { PageHeader } from "../../components/typography/pageHeader";
import { AuthProfile } from "../../redux/features/auth/auth.types";
import { CreatedEvent } from "../../redux/features/event/event.types";
import { guestEventsLSKey, guestProfileLSKey } from "../../utils/constants";
import { LSGuestDetails } from "../../utils/types";

export const GuestHomePage = () => {
  const [eventsList, setEventsList] = useState<CreatedEvent[]>([]);
  const [profile, setProfile] = useState<Partial<AuthProfile>>();

  const navigate = useNavigate();

  useEffect(() => {
    const guestEventDetails = localStorage.getItem(guestEventsLSKey);
    const guestProfileDetails = localStorage.getItem(guestProfileLSKey);

    if (guestProfileDetails) {
      setProfile(JSON.parse(guestProfileDetails));
    }

    if (guestEventDetails) {
      const parsedEventDetails: LSGuestDetails = JSON.parse(guestEventDetails);

      setEventsList(
        parsedEventDetails.map((deet) => {
          return {
            ...deet.guest.eventId,
            userType: "guest",
            ticketCount:
              deet.purchase.reduce((acc, el) => {
                return acc + el.quantity;
              }, 0) ?? 0,
          };
        }),
      );
    }

    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between gap-4">
        <PageHeader
          header={
            <div className="flex gap-1.5">
              <span>Hello, {profile?.firstName} 😅</span>
            </div>
          }
        />
      </div>

      <div className="mt-8 flex flex-col gap-1">
        <div
          className="soft-shrink mb-2 w-full cursor-pointer"
          onClick={() => {
            navigate(
              `/signup/?email=${encodeURIComponent(profile?.email ?? "")}&firstName=${encodeURIComponent(profile?.firstName ?? "")}&lastName=${encodeURIComponent(profile?.lastName ?? "")}`,
            );
          }}
        >
          <InfoCard
            title="Never lose your event ticket 🎟️ "
            text="Click here to sign up and save your ticket to your account"
            className="max-w-full !bg-light-blue"
            rightIcon="arrow-right"
          />
        </div>

        <div className="flex w-full items-center gap-2 rounded-2xl bg-white p-3 text-xs font-bold text-grey-500">
          <Icon svg="clock" width={16} height={26} />
          <p>UPCOMING EVENTS</p>
        </div>

        {[undefined, 0].includes(eventsList.length) ? (
          <EmptyEventState eventStatus="upcoming" />
        ) : undefined}

        {eventsList.length > 0 ? (
          <div className="flex flex-col gap-3">
            {eventsList.map((event, idx) => {
              return (
                <FullEventCard
                  event={event}
                  idx={idx}
                  key={`${event._id}-${idx}`}
                />
              );
            })}
          </div>
        ) : undefined}
      </div>
    </div>
  );
};
